import React from 'react';
import { Form } from 'react-bootstrap';

const CustomInput = ({
    value,
    onChange,
    placeholder,
    name,
    error,
    required,
    type,
    onBlur,
    autoFocus,
    onFocus,
    ref,
    ...props
}) => {
    return (
        <Form.Group>
            <Form.Control
                placeholder={placeholder}
                value={value}
                name={name}
                onChange={onChange}
                required={required}
                type={type || 'text'}
                isInvalid={!!error}
                onBlur={onBlur}
                autoFocus={autoFocus}
                onFocus={onFocus}
                ref={ref}
                {...props}
            />
            {error && <Form.Text className="text-danger">{error}</Form.Text>}
        </Form.Group>
    );
};

export default CustomInput;
